// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const language = navigator.language.split('-')[0]; // get the language code (e.g. "en", "es", etc.)

i18n.use(initReactI18next).init({
  lng: language, // default language
  fallbackLng: 'en',
  resources: {
    en: {
      translation: require('./translations/en.json')
    },
    es: {
      translation: require('./translations/es.json')
    }
    // add more languages as needed
  }
});

export default i18n;